import { render } from "./LoansNewModalPopup.vue?vue&type=template&id=60dc9184&scoped=true"
import script from "./LoansNewModalPopup.vue?vue&type=script&lang=js"
export * from "./LoansNewModalPopup.vue?vue&type=script&lang=js"

import "./LoansNewModalPopup.vue?vue&type=style&index=0&id=60dc9184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dc9184"]])

export default __exports__